import React, { memo } from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'BONO 1 — Guía Completa de Anatomía Simplificada',
  description: 'Lo que realmente necesitas saber (y nada más) Comprende cada sistema sin perderte en explicaciones innecesarias.',
  image: 'https://cdn.magicpatterns.com/uploads/gYnsLxJCvGu4X3onqfef1R/bono_1.png'
}, {
  id: 2,
  title: 'BONO 2 — Plantillas de Anatomía para Practicar y Memorizar',
  description: 'Diagramas sin completar para imprimir o usar de forma digital. Ideales para fijar conocimientos antes de parciales y finales.',
  image: 'https://cdn.magicpatterns.com/uploads/ivyicNgxtk4PiS6XuGZJ7w/bono_2.png'
}, {
  id: 3,
  title: 'BONO 3 — Apuntes Clave para Exámenes',
  description: 'Lo que siempre aparece en los exámenes. Estructuras más preguntadas, conceptos frecuentes y errores comunes.',
  image: 'https://cdn.magicpatterns.com/uploads/eTMUtPqVandYsaoKaM67p5/bono_3.png'
}, {
  id: 4,
  title: 'BONO 4 — Método de Estudio para Anatomía',
  description: 'Aprende cómo estudiar mejor, memorizar más rápido y rendir con seguridad. Incluye técnicas prácticas para evitar la saturación y mejorar la retención.',
  image: 'https://cdn.magicpatterns.com/uploads/dtivPMrZQvvxS2zwEpTyGT/bono_4.png'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-gray-50 px-4" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <div className="text-center mb-12" data-id="element-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-21">
            🎁 Además, obtienes estos BONOS exclusivos
          </h2>
          <div className="inline-block bg-red-600 text-white font-bold text-lg px-6 py-2 rounded-full shadow-lg animate-bounce" data-id="element-22">
            🎁 ¡GRATIS por el día de hoy!
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-23">
          {bonuses.map(bonus => <div key={bonus.id} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 flex flex-col" data-id="element-24">
              <div className="p-6 bg-gray-50 border-b border-gray-100 flex justify-center cursor-pointer" onClick={scrollToPurchase} data-id="element-25">
                <img src={bonus.image} alt={bonus.title} className="h-64 object-contain hover:scale-105 transition-transform duration-300 drop-shadow-lg" data-id="element-26" />
              </div>
              <div className="p-8 flex-1 flex flex-col justify-center" data-id="element-27">
                <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-28">
                  {bonus.title}
                </h3>
                <p className="text-gray-600" data-id="element-29">{bonus.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}